// extracted by mini-css-extract-plugin
export default {"yandex-plus-warning":"WUb1f","yandex-plus-warning__image":"cY1H5","yandex-plus-warning__text":"YOGuy"};